import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

export default {
    methods: {

        // 获取下单宝贝列表 flag==true 表示新增入口
        GetBabyList(ClassId, BabyName,PackageId, flag) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                ClassId: ClassId,
                BabyName: BabyName,
                PackageId:PackageId
            };
            if (this.OrderSource !== '') {
                // 转介绍
                params.OrderSource = this.OrderSource
            }

            this.loading = true;
            this.lists = []
            this.lists2 = []
            $http.get("api/Baby/GetBabyList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {

                    if (this.OrderSource == 3) {
                        // 转介绍
                        for (let i = 0; i < Data.length; i++) {

                            this.lists2.push({
                                ClassId: Data[i].ClassId,
                                BabyId: Data[i].BabyId,
                                BabyName: Data[i].BabyName,
                                Sex: Data[i].Sex,
                                Birthday: Data[i].Birthday,
                                ParentId: Data[i].ParentId,
                                ParentName: Data[i].ParentList[0].ParentName,
                                ParentPhoneNo: Data[i].ParentList[0].ParentPhoneNo,
                                ParentNick: Data[i].ParentList[0].ParentNick
                            })
                        }
                    } else {
                        this.lists = Data;
                        if (flag) {
                            this.$emit('babyInfo', Data[0])
                            this.$emit('parentInfo', Data[0].ParentList[0])
                            this.dialogVisible = false
                        }

                    }
                    if (Data.length == 0) {
                        this.isTip = true
                    } else {
                        this.isTip = false
                    }
                });
            });
        },
        //无园所宝贝 api/Baby/GetBabyByPage
        GetBabyByPage(BabyName,PackageId,flag) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                BabyName: BabyName,
                PackageId:PackageId
            };
            if (this.OrderSource !== '') {
                // 转介绍
                params.OrderSource = this.OrderSource
            }

            this.loading = true;
            this.lists = []
            this.lists2 = []
            $http.get("api/Baby/GetBabyByPage", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {

                    if (this.OrderSource == 3) {
                        // 转介绍
                        for (let i = 0; i < Data.length; i++) {
                            this.lists2.push({
                                ClassId: Data[i].ClassId,
                                BabyId: Data[i].BabyId,
                                BabyName: Data[i].BabyName,
                                Sex: Data[i].Sex,
                                Birthday: Data[i].Birthday,
                                ParentId: Data[i].ParentId,
                                ParentName: Data[i].ParentList[0].ParentName,
                                ParentPhoneNo: Data[i].ParentList[0].ParentPhoneNo,
                                ParentNick: Data[i].ParentList[0].ParentNick
                            })
                        }
                    } else {
                        this.lists = Data;
                        if (flag) {
                            this.$emit('babyInfo', Data[0])
                            this.$emit('parentInfo', Data[0].ParentList[0])
                            this.dialogVisible = false
                        }
                    }
                    if (Data.length == 0) {
                        this.isTip = true
                    } else {
                        this.isTip = false
                    }
                    this.totalSize = Cnt
                });
            });
        },

    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/LBHomeOrder/components/babyList/services.js